export default __webpack_public_path__ + "static/media/image-anousheh-ansari.2d647128.png";